// extracted by mini-css-extract-plugin
export default {"message":"Message_message__Ti2gu","right":"Message_right__hIlwb","left":"Message_left__jAD0c"};